export default "__VITE_ASSET__COmzPhHW__"